const defaultTheme = {
	primaryColor: '#01487C',
	accentColor: '#5AB782',
	errorColor: '#c00',
}

export default defaultTheme
